import axios from 'axios';
import { FILE_TYPES } from './constants';

export { FILE_TYPES };

interface FileEntry {
    id: string;
    asset: {
        kind: string;
        src: string;
    };
}

export async function addFile(files: FileList | File[] | null | undefined, fileType: string): Promise<unknown> {
    if (!Object.values(FILE_TYPES).includes(fileType as (typeof FILE_TYPES)[keyof typeof FILE_TYPES])) {
        throw new Error('Invalid type of file to add.');
    } else if (files && files.length) {
        const data = new FormData();
        Array.from(files).forEach((file) => {
            data.append('files', file);
        });
        try {
            return await axios.post(`/api/files?path=${fileType}`, data);
        } catch (err) {
            const error = err as { response?: { status: number } };
            if (error.response) {
                if (error.response.status === 413) {
                    throw new Error('File size is too large (should be 32MB or smaller)');
                }
            }
            throw err;
        }
    } else {
        throw new Error('No files provided');
    }
}

export async function getFiles(fileType: string): Promise<FileEntry[]> {
    if (!Object.values(FILE_TYPES).includes(fileType as (typeof FILE_TYPES)[keyof typeof FILE_TYPES])) {
        throw new Error(`Invalid type of file to query. May be one of ${Object.values(FILE_TYPES).join(', ')}`);
    } else {
        return axios.get(`/api/files?path=${fileType}`).then((result) => {
            const { data } = result;
            if (Array.isArray(data)) {
                return data.map((image: { id: string; url: string }) => {
                    return {
                        id: image.id,
                        asset: {
                            kind: 'image',
                            src: image.url,
                        },
                    };
                });
            }
            return [];
        });
    }
}

export async function addCampaign(files: FileList | File[] | null | undefined): Promise<unknown> {
    return addFile(files, FILE_TYPES.CAMPAIGN);
}

export async function getCampaigns(): Promise<FileEntry[]> {
    return getFiles(FILE_TYPES.CAMPAIGN);
}

export async function addCharacter(files: FileList | File[] | null | undefined): Promise<unknown> {
    return addFile(files, FILE_TYPES.CHARACTER);
}

export async function getCharacters(): Promise<FileEntry[]> {
    return getFiles(FILE_TYPES.CHARACTER);
}

export async function addMap(files: FileList | File[] | null | undefined): Promise<unknown> {
    return addFile(files, FILE_TYPES.MAP);
}

export async function getMaps(): Promise<FileEntry[]> {
    return getFiles(FILE_TYPES.MAP);
}
